export enum LoginProp {
  username = 'username',
  password = 'password',
  isRememberUsername = 'isRememberUsername',
}

export const initialLoginForm = {
  [LoginProp.username]: '',
  [LoginProp.password]: '',
  [LoginProp.isRememberUsername]: false,
};
